import {
  proposalAuthorisedConstants,
  proposalOnAcceptanceConstants,
} from '../constants/actionTypes'
import * as proposalService from '../services/proposalsService'

export const OnProposalAuthorisation = (value) => {
  switch (value) {
    case proposalAuthorisedConstants.PROPOSAL_AUTHORISED:
      return {
        type: proposalAuthorisedConstants.PROPOSAL_AUTHORISED,
      }
    case proposalAuthorisedConstants.PROPOSAL_NOT_AUTHORISED:
      return {
        type: proposalAuthorisedConstants.PROPOSAL_NOT_AUTHORISED,
      }
    case proposalAuthorisedConstants.PROPOSAL_ID_RECEIVED:
      return {
        type: proposalAuthorisedConstants.PROPOSAL_ID_RECEIVED,
      }
  }
}

export const OnProposalIDReceived = (proposal) => {
  return {
    type: proposalAuthorisedConstants.PROPOSAL_ID_RECEIVED,
    payload: proposal,
  }
}

export const OnProposalAcceptance = (oppurtunityId, proposal, history, pdf) => {
  let inputDetails = proposal.proposal
  inputDetails.acceptedOn = new Date()
  inputDetails.cancelledOn = null
  inputDetails.pdfBase64 = pdf

  return (dispatch) => {
    return proposalService.OnProposalAcceptance(
      oppurtunityId,
      inputDetails,
      dispatch,
      history
    )
  }
}

export const WaitOnProposalAcceptanceSubmission = () => {
  return {
    type: proposalOnAcceptanceConstants.PROPOSAL_ACCEPTANCE_SUBMITTING,
  }
}

export const OnProposalAcceptanceFailed = (error) => {
  return {
    type: proposalOnAcceptanceConstants.PROPOSAL_ACCEPTANCE_FAILED,
    payload: error,
  }
}

export const OnCancelProposalAcceptance = (oppurtunityId, proposal) => {
  let inputDetails = proposal
  inputDetails.acceptedOn = new Date(1900, 0, 1)
  inputDetails.cancelledOn = new Date()

  return (dispatch) => {
    return proposalService.OnCancelProposalAcceptance(
      oppurtunityId,
      inputDetails,
      dispatch
    )
  }
}

export const WaitOnCancelProposalAcceptanceSubmission = () => {
  return {
    type: proposalOnAcceptanceConstants.CANCEL_PROPOSAL_ACCEPTANCE_SUBMITTING,
  }
}

export const OnCancelProposalAcceptanceFailed = (response) => {
  return {
    type: proposalOnAcceptanceConstants.CANCEL_PROPOSAL_ACCEPTANCE_FAILED,
    payload: response,
  }
}

export const OnCancelProposalAcceptanceSuccess = () => {
  return {
    type: proposalOnAcceptanceConstants.CANCEL_PROPOSAL_ACCEPTANCE_SUCCESS,
  }
}
